import Outcome from './Outcome'

export default [
    {
        path: '/outcome',
        component: Outcome,
    },
    {
        path: '/outcome/:questionnaire',
        component: Outcome,
        props: true
    }
]
